"use client";

import Analytics from "@/components/common/Analytics";
import Styles from "@/components/common/Styles";
import UtmCapture from "@/components/common/UtmCapture";

/**
 * Shared body-level scripts and components used by all layouts.
 * PostHog pageviews are captured by {@link PostHogRoot} in route-group layouts.
 */
export function LayoutBodyScripts() {
  return (
    <>
      <Analytics />
      <UtmCapture />
      <Styles />
    </>
  );
}
